var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#84DCC8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6654 36.0007C52.6654 45.2054 45.2034 52.6673 35.9987 52.6673C26.794 52.6673 19.332 45.2054 19.332 36.0007C19.332 26.7959 26.794 19.334 35.9987 19.334C45.2034 19.334 52.6654 26.7959 52.6654 36.0007Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7185 30.9501C43.2067 31.4383 43.2067 32.2297 42.7185 32.7179L34.3852 41.0512C33.897 41.5394 33.1056 41.5394 32.6174 41.0512L29.2841 37.7179C28.7959 37.2297 28.7959 36.4383 29.2841 35.9501C29.7722 35.4619 30.5637 35.4619 31.0519 35.9501L33.5013 38.3996L37.226 34.6748L40.9508 30.9501C41.4389 30.4619 42.2304 30.4619 42.7185 30.9501Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccess);
export default __webpack_public_path__ + "static/media/order-success.ffdcb51a33fbbe6e6b940f5a2d785fa3.svg";
export { ForwardRef as ReactComponent };